import React, { useState } from 'react';

function Footer() {
   return (
    <footer className="tj-footer-section footer-1 section-gap-x">
      <div className="footer-main-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget wow fadeInUp" data-wow-delay=".1s">
                <div className="footer-logo">
                  <a href="/">
                    <img src="assets/images/logos/logo-2.png" alt="Logos" />
                  </a>
                </div>
                <div className="footer-text">
                  <p>Leading manufacturer of pharmaceutical machinery including tablet press, roll compactor, and complete production line equipment. Quality machines with cGMP compliance.</p>
                </div>
                <div className="award-logo-area">
                  <div className="award-logo">
                    <img src="assets/images/footer/award-logo-1.webp" alt="" />
                  </div>
                  <div className="award-logo">
                    <img src="assets/images/footer/award-logo-2.webp" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              <div className="footer-widget widget-nav-menu wow fadeInUp" data-wow-delay=".3s">
                <h5 className="title">Our Products</h5>
                <ul>
                  <li><a href="/single-rotary-tablet-press">Single Rotary Tablet Press (GMP)</a></li>
                  <li><a href="/single-rotary-tablet-press-non-gmp">Single Rotary Tablet Press (NON GMP)</a></li>
                  <li><a href="/mini-rotary-tablet-press">Mini Rotary Tablet Press</a></li>
                  <li><a href="/fluid-bed-dryer">Fluid Bed Dryer</a></li>
                  <li><a href="/rapid-mixer-granulator">Rapid Mixer Granulator</a></li>
                  <li><a href="/services">View All Products</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-2 col-lg-4 col-md-6">
              <div className="footer-widget widget-nav-menu wow fadeInUp" data-wow-delay=".5s">
                <h5 className="title">Quick Links</h5>
                <ul>
                  <li><a href="/about">About Us</a></li>
                  <li><a href="/services">Our Products</a></li>
                  <li><a href="/contact">Contact Us</a></li>
                  <li><a href="/contact">Get Quote</a></li>
                  <li><a href="/services">Catalog</a></li>
                  <li><a href="/contact">Support</a></li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-5 col-md-6">
              <div className="footer-widget widget-subscribe wow fadeInUp" data-wow-delay=".7s">
                <h3 className="title">Subscribe to Our Newsletter.</h3>
                <div className="subscribe-form">
                  <div>
                    <input type="email" name="email" placeholder="Enter email" />
                    <button type="button"><i className="fa-solid fa-paper-plane"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tj-copyright-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="copyright-content-area">
                <div className="footer-contact">
                  <ul>
                    <li>
                      <a href="tel:+919537503030">
                        <span className="icon"><i className="fa-solid fa-phone"></i></span>
                        <span className="text">+91 95375 03030</span>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:sdpharma795@gmail.com">
                        <span className="icon"><i className="fa-solid fa-envelope"></i></span>
                        <span className="text">sdpharma795@gmail.com</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="social-links">
                  <ul>
                    <li>
                      <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="copyright-text">
                  <p>&copy; 2025 <a href="/" target="_blank" rel="noopener noreferrer">SD Pharma</a> All right reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-shape-1">
        <img src="assets/images/shape/pattern-2.svg" alt="" />
      </div>
      <div className="bg-shape-2">
        <img src="assets/images/shape/pattern-3.svg" alt="" />
      </div>
    </footer>
  );
}
 

export default Footer;